import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import HistoryCard from './history-card.presentation';
import {
  downloadMyPaymentOrderAsync,
  setMyPaymentHistorySearchText,
  setTappedPaymentHistoryProformaNo,
  showErrorSnackbar,
} from '../../redux/action';
import LocalizedString from '../../localization';
import { CART_TAB_CIP } from '../../constant';
import {
  isCgsItem, isShowCartTabs, unauthorizedErrorHandler, toMoment,
} from '../../helper';

const getFilteredBl = (state, data) => _.values(data)
  .filter((item) => {
    const searchText = state.uiMyPaymentHistory.searchBarText.toLowerCase();
    const itemsFound = item.items.find((detailItem) => {
      const invoiceNo = detailItem.invoiceNo || '-';
      const blNumber = detailItem.blNumber || '-';
      const service = detailItem.service || '-';

      return invoiceNo.toLowerCase().indexOf(searchText) >= 0
        || blNumber.toLowerCase().indexOf(searchText) >= 0
        || service.toLowerCase().indexOf(searchText) >= 0;
    });
    return item.proformaNo.toLowerCase()
      .indexOf(searchText) >= 0
      || itemsFound;
  })
  .sort((left, right) => toMoment(right.createdDate) - toMoment(left.createdDate));

const isCgsChildren = item => item.items.some(x => isCgsItem(x));

const getData = (state) => {
  const { currentUser, myOrder, uiMyPayment } = state;
  const { selectedInnerTab } = uiMyPayment;

  const hasBothPaymentMethods = isShowCartTabs(currentUser.company);

  if (hasBothPaymentMethods) {
    const initData = Object.values(myOrder);
    const cipTabData = initData.filter(x => !isCgsChildren(x));
    const cgsTabData = initData.filter(x => isCgsChildren(x));
    const result = selectedInnerTab === CART_TAB_CIP ? cipTabData : cgsTabData;
    return getFilteredBl(state, result);
  }
  return getFilteredBl(state, myOrder);
};

const mapStateToProps = state => ({
  downloading: state.uiMyPaymentHistory.downloading,
  bl: getData(state),
  searchBarText: state.uiMyPaymentHistory.searchBarText,
  selectedProformaNo: state.uiMyPaymentHistory.tappedProformaNo,
  userCompany: state.currentUser.company,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAppear: async () => {
    try {
      await dispatch(downloadMyPaymentOrderAsync());
    } catch (error) {
      dispatch(showErrorSnackbar(LocalizedString.common.alertTitleError, error.message));
      unauthorizedErrorHandler(error, ownProps.history.push);
    }
  },
  onChangeSearchBarText: (text) => {
    dispatch(setMyPaymentHistorySearchText(text));
  },
  onMorePressed: (tappedProformaNo) => {
    dispatch(setTappedPaymentHistoryProformaNo(tappedProformaNo));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HistoryCard));
